import React from "react";
import { Search } from "lucide-react";

import "./SearchField.css";

const SearchField = ({
  type = "search",
  value,
  defaultValue,
  placeholder = "Search...",
  onChange,
  onKeyDown,
  onEnter,
  onSearch,
  disabled = false,
  className = "",
  icon = <Search size={18} />,
  iconPosition = "left",
  inputStyle,
  mainContainerStyle,
  name,
  maxLength,
  onBlur,
  readOnly = false,
}) => {
  const isControlled = value !== undefined;
  const isReadOnly = readOnly || (isControlled && !onChange);
  const hasSearchAction = Boolean(onSearch || onEnter);

  const handleKeyDown = (event) => {
    onKeyDown?.(event);

    if (
      event.defaultPrevented ||
      event.key !== "Enter" ||
      event.nativeEvent?.isComposing ||
      disabled ||
      isReadOnly
    ) {
      return;
    }

    if (hasSearchAction) {
      event.preventDefault();
      (onEnter || onSearch)(event);
    }
  };

  const handleSearch = (event) => {
    if (disabled || isReadOnly) return;
    (onSearch || onEnter)?.(event);
  };

  return (
    <div
      className={[
        "katch-form-search",
        disabled && "katch-form-search--disabled",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={mainContainerStyle}
    >
      <div className="katch-form-search__input-wrapper">
        <input
          type={type}
          name={name}
          value={isControlled ? (value ?? "") : undefined}
          defaultValue={!isControlled ? defaultValue : undefined}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={isReadOnly}
          style={inputStyle}
          className={[
            "katch-form-search__field",
            icon && `katch-form-search__field--${iconPosition}`,
          ]
            .filter(Boolean)
            .join(" ")}
        />

        {icon && (
          <button
            type="button"
            className={[
              "katch-form-search__button",
              `katch-form-search__button--${iconPosition}`,
            ].join(" ")}
            onClick={handleSearch}
            disabled={disabled || isReadOnly || !hasSearchAction}
            aria-label="Search"
            title="Search"
          >
            {icon}
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchField;
